export default {
  setPlantillasDisponibles(state, p) {
    state.plantillasDisponibles = p;
  }
}